/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
// Utilities
import { mapState } from "vuex";
import LocalStore from "../utilities/local-store-manager";
import DefaultRouteEngine from "../utilities/default-route-engine";
import QueryStringHelper from "../utilities/query-string-helper";
import BaseProxy from "@/proxies/base-proxy";
import axios from "axios";
import getAppCustomEnv from "@/utilities/get-app-custom-env";
import { isPartner } from "../utilities/partner-util";

import { Constants } from "customer-sdk/constants";

const PAGE_URLS = Constants.PAGE_URLS;
export const LoginMixin = {
  computed: {
    ...mapState("configModule", ["platformConfig"]),
  },
  methods: {
    loginUser: async (component, data) => {
      let localStore = new LocalStore();
      await localStore.storeProfile(component, data);
      let queryStringHelper = new QueryStringHelper();
      let redirect = queryStringHelper.getRedirectUrlFriendly("redirect");
      const appCustomEnv = await getAppCustomEnv();
      const isCurrentUserAPartner = await isPartner();

      //const isProdOrStaging = appCustomEnv.VUE_APP_SLEEK_ENV === "production" || appCustomEnv.VUE_APP_SLEEK_ENV === "staging";
      const isProd = appCustomEnv.VUE_APP_SLEEK_ENV === "production";
      if (!isCurrentUserAPartner && isProd) {
        let email = data.email || "";
        let baseProxy = new BaseProxy();
        let backendUrl = await baseProxy.getBackendUrl();
        let endpointUrl = `${backendUrl}/v2/crm-service/hsf`;

        const hubspotutkCookie = document.cookie.match(/hubspotutk\s*=\s*([^;]+)/g) || [];
        if (hubspotutkCookie.length) {
          hubspotutkCookie.forEach(async (cookie) => {
            const input = {
              hutk: cookie.replace("hubspotutk=", ""),
              email: email,
            }; // await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
            await axios
              .post(endpointUrl, input, {
                headers: {
                  Authorization: data.authToken,
                  "Content-Type": "application/JSON",
                },
              })
              .catch((error) => {
                console.log(`hsf error: ${error}`);
              });
          });
        }
      }
      const isTwoFactor = localStore.getIsTwoFactor();

      if (!isTwoFactor) {
        if ((data || {}).isPartnerAdmin) {
          window.location.href = PAGE_URLS.PARTNER.INDEX;
        } else if (redirect) {
          let invitationToken = queryStringHelper.getRedirectUrlFriendly("invitationToken");
          let isFromKycResubmissionRequest = queryStringHelper.getRedirectUrlFriendly("isFromKycResubmissionRequest");
          if (invitationToken && isFromKycResubmissionRequest === "true") {
            window.location.href = `${PAGE_URLS.MEMBER_INVITATION}?invitation_token=${invitationToken}`;
            // return;
          }

          window.location.href = redirect;
        } else {
          let routeEngine = new DefaultRouteEngine();
          component.$router.push(await routeEngine.execute(component, { isFromLogin: true }));
        }
      }
    },
  },
};
